// Module
var code = "<div layout=\"column\" class=\"full-height\"> <sms-messages-table flex infinite-scroll=\"$ctrl.infiniteScroll\"> </sms-messages-table> </div> ";
// Exports
export default code;